export const RESET = 'EXSBDOCUMENT_UPDATE_RESET'
export const SET_ERROR = 'EXSBDOCUMENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBDOCUMENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBDOCUMENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBDOCUMENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBDOCUMENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBDOCUMENT_UPDATE_UPDATE_RETRIEVED'
